export default "__VITE_ASSET__DGteZjCE__"